import React from 'react';
import { AppBar, Toolbar, Button, Avatar } from 'material-ui';
import { Link } from 'react-router-dom'
import store from 'store';
import isLoggedIn from '../helpers/isLoggedIn';
import BackButton from './BackButton';
import NotifPopover from './CustomNotificationPopover'

const handleLogout = () => {
    store.remove('loggedIn');
};


class NavBar extends React.Component {

    render() {
        
        return (
            <div >
                <AppBar position="static" className="navbar">
                    <Toolbar>
                        <BackButton />
                        <div className="right-menu">
                            <NotifPopover/>
                            <Avatar src={require("../images/me.jpg")}></Avatar>
                        {(() => {
                            if (!isLoggedIn()) {
                                return <Link to='/login'><Button color="contrast">Login</Button></Link>
                            } else {
                                return <Link to='/login' onClick={handleLogout}><Button color="contrast">Log out</Button></Link>
                            }
                        })()}
                        </div>
                    </Toolbar>
                </AppBar>
            </div >
        )
    };
}
export default NavBar


// WEBPACK FOOTER //
// ./src/components/NavBar.js